import isEmpty from 'lodash/isEmpty.js';
import isArray from 'lodash/isArray.js';

const getSelectedChoicesWithTag = (options, choices, texture) => {
  if (isEmpty(options) || isEmpty(choices)) return null;

  const textureOptions = options?.topLevelOptions?.reduce((acc, option) => {
    const availableOptionTags = options[option]?.tags;

    if (isArray(availableOptionTags) && !isEmpty(availableOptionTags)) {
      const hasTexture = availableOptionTags.find(tag => tag === texture);
      if (hasTexture) {
        acc.push(options[option]);
      }

      return acc;
    }

    return acc;
  }, []);

  const selectedChoices = textureOptions?.reduce((acc, option) => {
    const availableChoices = option?.choices;

    if (isArray(availableChoices) && !isEmpty(availableChoices)) {
      const allOptionChoices = availableChoices.map(choice => choices[choice]);
      const selectedOptionChoice = allOptionChoices.find(optionChoice => optionChoice?.isSelected);

      if (isArray(availableChoices) && !isEmpty(availableChoices)) {
        acc.push(selectedOptionChoice);
      }

      return acc;
    }

    return acc;
  }, []);

  return selectedChoices;
};

export default getSelectedChoicesWithTag;
